// extracted by mini-css-extract-plugin
export default {"button":"Login_button__ASz6g","logo":"Login_logo__WfGma"};